<template>
  <div :class="paddingClass"><slot /></div>
</template>
<script lang="ts" setup>
  import { computed, defineProps } from 'vue';

  const props = defineProps({
    padding: {
      type: String,
      default: 'py-5',
    },
  });

  const paddingClass = computed(() => props.padding);
</script>
